export default __webpack_public_path__ + "static/media/discord-inactive.069459b6.svg";